module.exports = __webpack_public_path__ + "img/img_tskbg1@2x.1a90e042.png";